<div class="container pia-mainContainerBlock pia-knowledges_base">
  <div class="row">
    <div class="small-12 medium-12 columns">
      <div class="pia-breadcrumb">
        <a [routerLink]="['/entries', 'knowledge_bases']">{{
          "header.knowledge_base_link" | translate
        }}</a
        ><strong> > {{ base.name }}</strong>
      </div>
      <div class="pia-filtersBlock">
        <div class="small-12 medium-9 columns pia-sectionBlock-header">
          <h1 class="truncate" title="{{ base.name }}">{{ base.name }}</h1>
          <a
            class="pia-icons pia-icon-close-big"
            [routerLink]="['/entries', 'knowledge_bases']"
            title="{{ 'summary.previous_page' | translate }}"
          ></a>
        </div>

        <div class="pia-filtersBlock-left">
          <div class="pia-filtersBlock-buttons">
            @if (!base.is_example) {
            <button
              type="button"
              class="btn btn-red"
              (click)="
                showForm = true;
                editMode = 'new';
                entryForm.reset();
                selectedKnowledgeId = null;
                itemsSelected = []
              "
            >
              <fa-icon [icon]="faFolderOpen"></fa-icon
              >{{ "homepage.cards.knowledges_entry.new" | translate }}
            </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="small-9 medium-9 columns">
      <table class="pia-list-table">
        <thead>
          <tr>
            @if (!base.is_example) {
            <th style="width:75px;"></th>
            }
            <th colspan="2">
              <a
                ><span>{{
                  "homepage.cards.knowledges_entry.placeholder_name" | translate
                }}</span></a
              >
            </th>
            <th style="width:260px;">
              <a
                ><span>{{
                  "homepage.cards.knowledges_entry.placeholder_category"
                    | translate
                }}</span></a
              >
            </th>
            <th style="width:130px;text-align:center;">
              <a
                ><span>{{
                  "homepage.cards.knowledges_entry.placeholder_updated_at"
                    | translate
                }}</span></a
              >
            </th>
          </tr>
        </thead>
        @if (knowledges && knowledges.length > 0) {
        <tbody>
          @for (item of knowledges; track trackByKnowledgeId($index, item)) {
          <tr [ngClass]="{ noElementsDisplaying: showForm }">
            @if (!base.is_example) {
            <td class="pia-listsBlock-item">
              <a
                href="javascript:;"
                (click)="duplicate(item.id)"
                class="btn pia-tooltip"
              >
                <fa-icon [icon]="faCopy"></fa-icon>
                <span
                  title="{{
                    'homepage.cards.item.tools.duplicate' | translate
                  }}"
                  class="pia-tooltip-text"
                >
                  {{ "homepage.cards.item.tools.duplicate" | translate }}
                </span>
              </a>
              <a (click)="delete(item.id)" class="btn pia-tooltip">
                <fa-icon [icon]="faTrash"></fa-icon>
                <span
                  title="{{ 'homepage.cards.item.tools.remove' | translate }}"
                  class="pia-tooltip-text"
                  >{{ "homepage.lists.item.tools.remove" | translate }}</span
                >
              </a>
            </td>
            }
            <td
              class="pia-listsBlock-item-click"
              (click)="editEntry(item.id)"
              colspan="2"
            >
              @if (!base.is_example) {
              {{ item.name }}
              } @else {
              {{ item.name | translate }}
              }
            </td>
            <td class="pia-listsBlock-item-click" (click)="editEntry(item.id)">
              {{ item.category | translate }}
            </td>
            <td
              class="pia-listsBlock-item-click"
              (click)="editEntry(item.id)"
              style="text-align:center;"
            >
              {{
                item.updated_at
                  | date: "shortDate":"":languagesService.selectedLanguage
              }}
            </td>
            <!-- Display element data block in absolute -->
            <td class="pia-knowledges_base-displayData">
              <h3>
                {{ "homepage.cards.knowledges_entry.contents" | translate }}
              </h3>
              <div class="pia-knowledges_base-displayData-category">
                {{ item.category | translate }}
              </div>
              <div class="pia-knowledges_base-displayData-name">
                @if (!base.is_example) {
                {{ item.name }}
                } @else {
                {{ item.name | translate }}
                }
              </div>
              <div class="pia-knowledges_base-displayData-description">
                @if (!base.is_example) {
                <div [innerHTML]="item.description"></div>
                } @else {
                <div [innerHTML]="item.description | translate"></div>
                }
              </div>
            </td>
          </tr>
          }
        </tbody>
        }
      </table>
    </div>

    <!-- NEW ENTRY FORM -->
    @if (!loadingEntry) {
    <div class="small-3 medium-3 columns">
      @if (showForm) {
      <form
        (ngSubmit)="onSubmit()"
        [formGroup]="entryForm"
        class="pia-knowledges_base-form"
      >
        <button
          (click)="closeNewElementForm()"
          class="pia-knowledges_base-form-close"
          type="button"
        >
          <span class="pia-icons pia-icon-close"></span>
        </button>
        <h3>{{ "homepage.cards.knowledges_entry.contents" | translate }}</h3>
        <div>
          <div class="pia-elementCategory-wrapper">
            <select
              name="category"
              formControlName="category"
              (change)="checkLockedChoice(); focusOut()"
              required
            >
              <option value="null" disabled>{{
                "homepage.cards.knowledges_entry.choose_category" | translate
              }}</option>
              @for (category of categories; track category) {
              <option value="{{ category }}">{{ category | translate }}</option>
              }
            </select>
          </div>
        </div>
        <div>
          <input
            (focusout)="focusOut('name')"
            formControlName="name"
            type="text"
            placeholder="{{
              'homepage.cards.knowledges_entry.placeholder_name' | translate
            }}"
            name="name"
            required
          />
        </div>
        <div>
          <textarea
            (focusout)="focusOut('description')"
            formControlName="description"
            type="text"
            placeholder="{{
              'homepage.cards.knowledges_entry.placeholder_description'
                | translate
            }}"
            name="description"
            required
          ></textarea>
        </div>

        <h3>{{ "homepage.cards.knowledges_entry.linked_to" | translate }}</h3>

        @if (data && data.sections.length > 0) {
        <div class="pia-knowledges_base-form-checkboxes">
          <!-- "SELECT ALL SECTIONS" CHECKBOX -->
          <!-- Hidden if current category is linked to measures -->
          @if (!this.lockedChoice) {
          <div class="pia-knowledges_base-form-checkboxes-title">
            <input
              id="select_all_sections"
              name="select_all_sections"
              type="checkbox"
              [disabled]="lockedChoice"
              (click)="globalCheckingAllElementInDataSection($event)"
              [checked]="allSectionCheckedVerification(data?.sections)"
            />
            <label for="select_all_sections">{{
              "homepage.cards.knowledges_entry.all_sections" | translate
            }}</label>
          </div>
          }
          <div class="pia-knowledges_base-form-checkboxes-body">
            @for (dataSection of data?.sections; track dataSection) {
            <div>
              <!-- SECTION CHECKBOXES -->
              <!-- Each section checkbox is disabled if current category is linked to measures -->
              <div class="pia-knowledges_base-form-checkboxes-title">
                <input
                  id="{{ dataSection.title }}"
                  name="{{ dataSection.title }}"
                  type="checkbox"
                  [disabled]="lockedChoice"
                  (click)="
                    globalCheckingElementInDataSection(dataSection, $event)
                  "
                  [checked]="sectionCheckedVerification(dataSection)"
                />
                <label for="{{ dataSection.title }}">{{
                  dataSection.title | translate
                }}</label>
              </div>

              <!-- SECTION ITEM CHECKBOXES -->
              <!-- Special case 1: item '31' is checked and disabled when current category is linked to measures -->
              <!-- Special case 2: item '31' is checkable when current category is 'definition' -->
              <!-- Special case 3: item '31' is disabled and not checkable in any other case -->
              <ul class="pia-knowledges_base-form-checkboxes-list">
                @for (dataItem of dataSection?.items; track dataItem) {
                <li>
                  <label for="{{ dataItem.title }}">
                    <input
                      [checked]="
                        itemsSelected.includes(
                          dataSection.id.toString() + dataItem.id.toString()
                        )
                      "
                      (change)="onCheckboxChange($event)"
                      type="checkbox"
                      name="{{ dataItem.title }}"
                      id="{{ dataItem.title }}"
                      value="{{
                        dataSection.id.toString() + dataItem.id.toString()
                      }}"
                      [disabled]="
                        (dataSection.id.toString() + dataItem.id.toString() ===
                          '31' &&
                          (entryForm.value.category ===
                            'knowledge_base.category.organizational_measure' ||
                            entryForm.value.category ===
                              'knowledge_base.category.measure_on_data' ||
                            entryForm.value.category ===
                              'knowledge_base.category.general_measure')) ||
                        (lockedChoice &&
                          dataSection.id.toString() + dataItem.id.toString() !==
                            '31') ||
                        (!lockedChoice &&
                          dataSection.id.toString() + dataItem.id.toString() ===
                            '31' &&
                          entryForm.value.category !==
                            'knowledge_base.category.definition')
                      "
                    />
                    <span
                      title="{{ dataItem.title | translate }}"
                      class="truncate"
                      >{{ dataItem.title | translate }}</span
                    >
                  </label>
                </li>
                }
              </ul>
            </div>
            }
          </div>
        </div>
        }
        <!-- Submit button (new element) -->
        @if (editMode === 'new') {
        <div>
          <button
            type="submit"
            [disabled]="entryForm.invalid"
            class="btn btn-red"
            id="structure-save-card-btn"
            title="{{ 'homepage.cards.placeholder_start' | translate }}"
          >
            {{ "homepage.cards.knowledges_entry.create" | translate }}
          </button>
        </div>
        }
      </form>
      }
    </div>
    } @else {
    <div
      class="small-3 medium-3 columns"
      style="position:relative; height: 150px;"
    >
      <app-loading-overlay
        [visibility]="true"
        [childMode]="true"
      ></app-loading-overlay>
    </div>
    }
  </div>
</div>

<app-dialog></app-dialog>
